import React, { useState, useEffect } from 'react';
import './App.css';
import i18next from 'i18next';

import  Uploads  from './components/Uploads';
import { useAuth } from './components/AuthContext';
import { auth } from './components/FireBase';
import { useAuthState } from "react-firebase-hooks/auth";

import UserDataGetLogin from './components/UserDataGetLogin';
import SiginButton from './components/SiginButton';
import SignOutButton from './components/SignOutButton';
import UserInfo from './components/UserInfo';

function App() {
  const { userId } = useAuth();
  const [user] = useAuthState(auth);
  const useIPAddress = () => {
    const [ipAddress, setIpAddress] = useState('');
    const [language, setLanguage] = useState(''); // 最初は空にしておく

    useEffect(() => {
      const fetchIp = async () => {
        try {
          const response = await fetch('https://user-data.kurikurikuricloud.com/');
          const data = await response.json();
          setIpAddress(data);

          // IPアドレスから地域情報を取得し、適切な言語を設定
          if (data.country === 'JP') {
            setLanguage('ja'); // 日本の場合
          } else if (data.country === 'US') {
            setLanguage('en'); // アメリカの場合
          } else if (data.country === 'CN') {
            setLanguage('cn'); // 中国の場合
          } else if (data.country === 'KR') {
            setLanguage('kr'); // 韓国の場合
          } else if (data.country === 'TW') {
            setLanguage('tw'); // 台湾の場合
          } else if (data.country === 'DE') {
            setLanguage('de'); // ドイツの場合
          } else if (data.country === 'ES') {
            setLanguage('es'); // スペインの場合
          } else if (data.country === 'BR') {
            setLanguage('br'); // ブラジルの場合
          } else if (data.country === 'IN') {
            setLanguage('hi'); // インドの場合
          } else if (data.country === 'RU') {
            setLanguage('ru'); // ロシアの場合
          } else if (data.country === 'VN') {
            setLanguage('vi'); // ベトナムの場合
          } else {
            setLanguage('en'); // 他の国の場合は英語
          }
        } catch (error) {
          console.error('IPアドレスの取得に失敗しました:', error);
        }
      };

      fetchIp();
    }, []);

    return { ipAddress, language };
  };

  const { ipAddress, language } = useIPAddress();
  
  const LinkStyle = {
    marginBottom: "16px"
  };

  // // languageが変更された時にi18nextの言語を変更
  // useEffect(() => {
  //   if (language) {
  //     console.log('Changing language to:', language);
  //     i18next.changeLanguage(language);
  //   }
  // }, [language]);
  return (
    <div className="App">
      <header className="App-header">
      </header>
      
      {user ? (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              justifyContent: 'space-between'

            }}>
            <SignOutButton />
    
          </div>


         
    
          <Uploads />
          <UserInfo />
   
        </>
      ) : (
        <>
          <div
            style={{
           
              display: 'flex',
              flexDirection: 'row-reverse',
              justifyContent: 'space-between'

            }}>
            <SiginButton />
        
          </div>
   
      
            <Uploads />
            <UserInfo />




        </>
      )}

      
      
      
      
      
      <>
  
        {/* <p>{userId !== null ? `ID: ${userId}` : "Geting your ID Now..."}</p> */}
        <UserDataGetLogin/>
      </>
    </div>

  );
}

export default App;
